import { changeIntegrationRetentionPeriod } from 'actions/integrationSettings';
import SelectRedesign from 'components/Select/SelectRedesign';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserCustomer } from 'selectors/auth';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const retentionOptions = [
  { value: '365', label: '1 year' },
  { value: '90', label: '90 days (most common)' },
  { value: '60', label: '60 days' },
  { value: '30', label: '30 days' },
  { value: '0', label: 'None' },
];

const RetentionPeriod: React.FC = () => {
  const dispatch = useDispatch();

  const customer = useSelector(getUserCustomer);
  const retentionPeriod = customer?.config?.communication_retention_days || 0;
  const integrationSettings = useSelector(getIntegrationSettingsForm);

  useEffect(() => {
    dispatch(changeIntegrationRetentionPeriod(retentionPeriod.toString()));
  }, [dispatch, retentionPeriod]);

  const handleChangeRetentionPeriod = (value: string): void => {
    dispatch(changeIntegrationRetentionPeriod(value));
  };

  return (
    <div className="flex flex-col gap-1 bg-white">
      <div className="flex flex-row">
        <span>Litlingo&apos;s retention period</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div className="w-88">
        <SelectRedesign
          onChange={handleChangeRetentionPeriod}
          options={retentionOptions}
          value={integrationSettings.retention_period}
        />
      </div>
    </div>
  );
};

export default RetentionPeriod;
